export default __webpack_public_path__ + "static/media/agustin10.d48de3b9.png";